var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.DashJS = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.isLive) {
      return this.player.timeAsUTC()
    } else {
      return this.player.time()
    }
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return null
  },

  /** Override to return Frames Per Secon (FPS) */
  getFramesPerSecond: function () {
    return null
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration()
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var level = this.player.getQualityFor("video")
    return this.player.getBitrateInfoListFor("video")[level].bitrate
  },

  /** Override to return user bandwidth throughput */
  getThroughput: function () {
    if (!this.throughput) {
      var metrics = this.player.getMetricsFor('video')
      var dashMetrics = this.player.getDashMetrics()
      var requests = dashMetrics.getHttpRequests(metrics)
      if (!requests) return null
      var bps = 0
      var bpsCount = 0
      for (var i = 0; i < requests.length; i++) {
        var req = requests[i]
        if (req.type == 'MediaSegment' && req.responsecode >= 200 && req.responsecode < 400 && req._stream == 'video') {
          var match = req._responseHeaders.match(/Content-Length: (.+)/i)
          if (match) {
            var time = (req.interval - (req.tresponse - req.trequest)) / 1000
            bps += (match[1] / time) * 8
            bpsCount++
          }
        }
      }
      if (!bps) return null
      this.throughput = bps / bpsCount
    }
    return this.throughput
  },

  /** Override to return rendition */
  getRendition: function () {
    return null
  },

  /** Override to return title */
  getTitle: function () {
    return null
  },

  /** Override to return title2 */
  getTitle2: function () {
    return null
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    if (!this.isLive) {
      this.isLive = false
    }
    return this.isLive
  },

  /** Override to return resource URL. */
  getResource: function () {
    var src = this.player.getSource()
    if (typeof src === 'string') {
      return src
    } else {
      return 'Manifest'
    }
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return null
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'dashJS'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // Register listeners
    this.player.on(dashjs.MediaPlayer.events.MANIFEST_LOADED, this.manifestLoaded.bind(this));
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_STARTED, this.playbackStarted.bind(this))
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_RATE_CHANGED, this.playbackRateChanged.bind(this))
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_PLAYING, this.playbackPlaying.bind(this))
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_PAUSED, this.playbackPaused.bind(this))
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_ENDED, this.playbackEnded.bind(this))
    this.player.on(dashjs.MediaPlayer.events.ERROR, this.errorListener.bind(this))
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_ERROR, this.playbackError.bind(this))
    this.player.on(dashjs.MediaPlayer.events.PLAYBACK_SEEKING, this.playbackSeeking.bind(this))
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    this.player.off(dashjs.MediaPlayer.events.MANIFEST_LOADED, this.manifestLoaded)
    this.player.off(dashjs.MediaPlayer.events.PLAYBACK_STARTED, this.playbackStarted)
    this.player.off(dashjs.MediaPlayer.events.PLAYBACK_RATE_CHANGED, this.playbackRateChanged)
    this.player.off(dashjs.MediaPlayer.events.PLAYBACK_PLAYING, this.playbackPlaying)
    this.player.off(dashjs.MediaPlayer.events.PLAYBACK_PAUSED, this.playbackPaused)
    this.player.off(dashjs.MediaPlayer.events.PLAYBACK_ENDED, this.playbackEnded)
    this.player.off(dashjs.MediaPlayer.events.ERROR, this.errorListener)
    this.player.off(dashjs.MediaPlayer.events.PLAYBACK_ERROR, this.playbackError)
    this.player.off(dashjs.MediaPlayer.events.PLAYBACK_SEEKING, this.playbackSeeking)

  },

  /** Listener for live. */
  manifestLoaded: function (e) {
    this.isLive = (e.data && e.data.type === 'dynamic')
  },

  /** Listener for playback rate. */
  playbackRateChanged: function (e) {
    youbora.Log.debug('playrate x' + e.playbackRate)
    if (e.playbackRate == 1) {
      this.PlayheadMonitor.lastPlayhead = 0;
    }
  },

  /** Listener for 'play' event. */
  playbackStarted: function (e) {
    this.fireStart()
  },

  /** Listener for 'pause' event. */
  playbackPaused: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playbackPlaying: function (e) {
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e.error + "_error")
  },

  /** Listener for 'error' event. */
  playbackError: function (e) {
    this.fireError(e.error + "_error")
  },

  /** Listener for 'seeking' event. */
  playbackSeeking: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'ended' event. */
  playbackEnded: function (e) {
    this.fireStop()
  },

  getCdnTraffic: function () {
    var allMetrics = this.player.getMetricsFor("p2pweb")
    if (!allMetrics) return null
    var metrics = allMetrics.metricsP2PWeb
    return metrics.videoAvgLength * metrics.chunksFromCDN +
      metrics.audioAvgLength * metrics.chunksFromCDN
  },

  getP2PTraffic: function () {
    var allMetrics = this.player.getMetricsFor("p2pweb")
    if (!allMetrics) return null
    var metrics = allMetrics.metricsP2PWeb
    return metrics.videoAvgLength * metrics.chunksFromP2P +
      metrics.audioAvgLength * metrics.chunksFromP2P
  }
})

module.exports = youbora.adapters.DashJS



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 24
// module chunks = 0